import { useEffect } from "react"
import { FieldValues, Path, UseFormReturn } from "react-hook-form"
import { useViaCep } from "@/services/queries/useViaCep"

export function useCepAutofill<T extends FieldValues>(
  form: UseFormReturn<T>,
  cepField: string,
  prefix: string = ""
) {
  const { data: address } = useViaCep({ zipCode: form.watch(cepField as Path<T>) })

  useEffect(() => {
    if (address) {
      form.setValue('address' as Path<T>, address.logradouro as any)
      form.setValue('neighborhood' as Path<T>, address.bairro as any)
      form.setValue('city' as Path<T>, `${address.localidade}, ${address.uf}` as any)
    }
  }, [address, form, prefix])
}
